import PropTypes from 'prop-types';
import React from 'react';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';

import _ from 'lodash';
import Button from 'react-bootstrap/lib/Button';

import { translate as t } from '../../lib/I18n';

import Icon from './Icon';
import PureRenderComponent from '../PureRenderComponent';


class Banner extends PureRenderComponent {

    static propTypes = {
        className: PropTypes.string,
        bodyClassName: PropTypes.string,
        children: PropTypes.node,
        showDismiss: PropTypes.bool,
        onDismiss: PropTypes.func
    };

    static defaultProps = {
        className: '',
        bodyClassName: '',
        children: null,
        showDismiss: false,
        onDismiss: _.noop
    };

    UNSAFE_componentWillMount () {
        const classes = document.body.className;
        document.body.className = classes + ' ' + this.props.bodyClassName;
    }

    componentWillUnmount () {
        const classes = document.body.className;
        document.body.className = classes.replace(this.props.bodyClassName, '');
    }

    render () {
        const { className, children, showDismiss, onDismiss } = this.props;

        return (
            <div className={ 'banner text-inverse text-weight--normal hidden-print clearfix ' + className }>
              <Row>
                <Col xs={ showDismiss ? 10 : 12 }>
                  { children }
                </Col>
                { showDismiss &&
                    <Col xs={ 2 }>
                        <Button className="btn-plain btn-dismiss" onClick={ onDismiss }>
                            <Icon icon="clear" className="otrl-inline" />
                            <span className="btn-dismiss__text">
                                          { t('global.banner.dismiss') }
                            </span>
                        </Button>
                    </Col>
                }
              </Row>
            </div>
        );
    }

}

export default Banner;



// WEBPACK FOOTER //
// ./src/components/general/Banner.js